import { memo } from 'react';
import { Link, cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Img from '@UI/Img';
import styles from './NewCollectionAnnounce.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { INewCollectionAnnounce } from '@Pages/PageProduct/typings';

export interface NewCollectionAnnounceProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  atrInfo?: INewCollectionAnnounce;
}

const NewCollectionAnnounce: FC<NewCollectionAnnounceProps> = (props) => {
  const { t } = useTranslation();
  const { atrInfo, ...restProps } = props;

  const hasSingleImage = atrInfo.main.image.length === 1;
  const hasMultipleImage = atrInfo.main.image.length > 1;

  return (
    <div {...restProps}>
      <div className={styles.text}>{atrInfo.header.text}</div>
      <div className={cn(styles.grid, { [styles.singleGrid]: hasSingleImage })}>
        <div className={cn({ [styles.photos]: hasMultipleImage })}>
          {atrInfo.main.image.map((img) => (
            <Img
              key={img}
              src={img}
              className={cn(styles.photo, { [styles.singlePhoto]: hasSingleImage })}
            />
          ))}
        </div>

        <div>
          <div className={styles.infoTitle}>{atrInfo.main.title}</div>
          <div className={cn(styles.infoText, { [styles.singleInfoText]: hasSingleImage })}>
            {atrInfo.main.text}
          </div>
          <Link
            className={styles.link}
            view='primary'
            to={atrInfo.main.link}
            target='_blank'
            underlined
          >
            {t('ui.more')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default memo(NewCollectionAnnounce);
